module.exports = __webpack_public_path__ + "static/media/linkedin.9708c8b5.svg";